<template>
  <div class="design-scene design-template layout-template">
    <div class="scene-slider" v-for="(item, ind) in recommendList" :key="ind">
      <div v-if="item.subjectList">
        <div class="scene-slider-title">
          <div class="content">
            
             <span class="name">{{item.name}}</span>
            <div class="tags">
              <router-link class="temp" :to="{name:'subjectId',params:{subjectId:item.id}}" target="_blank"> <span v-for="(t,i) in item.subjectList" :class="item.checkedId === t.id?'checked':''" :key="i" @mouseover="onTabs(item, t)">{{t.name}}</span></router-link>
            </div>
            
          </div>
         <router-link class="temp" :to="{name:'subjectId',params:{subjectId:item.id}}" target="_blank"> <a style="color:#000;font-weight:bold">查看全部></a></router-link>
        </div>
        <div class="scene-slider-list">

          <div class="scene-slider-list-content" v-if="item.checkedList">

            <swiper 
            
            :autoplay="item.option.autoplay" 
            :slides-per-view="item.option.slidesPerView" 
            :space-between="item.option.spaceBetween" 
            :loop="item.option.loop" 
            :speed="item.option.speed" 
            :slides-per-group="item.option.slidesPerGroup"
            :navigation="item.option.navigation">

              <swiper-slide class="scene-slide" v-for="(img, index) in item.checkedList.pptTemplateList.slice(0,16)" :key="index">
                <div 
                  class="layout-item"
                  v-if="index === 15"
                >
                  
                  <div class="img">
                      
                      <span class="scene-slider-more">查看更多></span>
                      <router-link class="temp" :to="{name:'subjectId',params:{subjectId:item.id}}" target="_blank"><img :src="img.image" style="opacity: 0;"/></router-link>
                    
                  </div>
                </div>
                <div 
                  class="layout-item"
                  v-if="index !== 15"
                >
                  <div class="template-item">
                    <div class="img">
                      <div class="info">
                      
                        <button class="preview-button" title="预览模板">
                          <router-link :to="{name:'templateId',params:{templateId:img.id}}" target="_blank">
                          <svg-icon name="preview1" width="18px" height="12px"></svg-icon></router-link></button>
                        <button class="collect-button" title="收藏模板" @click="onCollect(img.id)"><svg-icon name="template_collect" width="16px" height="15px"></svg-icon></button>
                      </div>
                      
                        <router-link class="temp" :to="'/editor?id=' + img.id" target="_blank"><img v-if="isChecked" :src="img.image" :title="img.title"/><img v-else :src="img.image" :title="img.title"/></router-link>
                      
                    </div>
          
                    <div class="title">
                      <span>{{img.title}}</span>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>

          </div>
            <div class="scene-slider-list-icon prev" :class="'prev'+ind">
              <svg-icon name="arrow" style="transform: rotate(180deg);"></svg-icon>
            </div>
            <div class="scene-slider-list-icon next" :class="'next'+ind">
              <svg-icon name="arrow"></svg-icon>
            </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive } from 'vue'
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper.scss'
import 'swiper/components/pagination/pagination.scss'
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay])
import { RecommendService } from '@/api/recommand'
import { MemberService } from '@/api/member'
import { message } from 'ant-design-vue'

export default defineComponent({
  name: 'DesignScene',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const recommendList = ref([])
    const isChecked = ref(true)
    const getRecommend = async () => {
      const params = {
      }
      const res = await RecommendService.getSubjectCategory(params)
      res.data.data.forEach((d: any, i: any) => {
        d.checkedList = d.subjectList[0]
        d.checkedId = d.subjectList[0] && d.subjectList[0].id ? d.subjectList[0].id : ''
        if (d.checkedList && d.checkedList.pptTemplateList) {
          d.checkedList.pptTemplateList.forEach(() => {
            const swiper_options = reactive({
              autoplay:false,
              navigation: {
                nextEl: '.scene-slider-list-icon.next' + i,
                prevEl: '.scene-slider-list-icon.prev' + i,
              },
              slidesPerView:8,
              spaceBetween: 20,
              slidesPerGroup:8,
              loop:false,
              speed:500,
              
            })
            d.option = swiper_options
          })
        }
      })
      recommendList.value = res.data.data
    }
    getRecommend()

    const onCollect = async (id: any) => {
      const params = {
        contentId:id
      }
      const res = await MemberService.addCollect(params)
      if (res.data.state === 2) {
        message.success('收藏成功')
      }
      else {
        message.error(res.data.msg)
      }
      
    }
    const onTabs = (d: any,t:any) => {
      d.checkedId = t.id
      d.checkedList = t
      isChecked.value = false
      
    }
    return {
      recommendList,
      onCollect,
      onTabs,
      isChecked
    }
  }
})
</script>

<style scoped lang="scss">
.scene-slide {
  width: auto;
  img {
    width: 100%;
    border-radius: 4px;
  }
}

.swiper-container {
  padding: 10px 0 20px 0;
}
.scene-slider-list {
  margin-left: 0;
}
</style>